import { useState } from "react";
import { useTranslation } from "react-i18next";
import SchoolPostFormPopupComponent from "src/components/admin/school-post-form-popup-component";
import { AddOfferValuesType } from "src/core/types/add-offer-form-type";

function SchoolOffersContainer() {
  const { t } = useTranslation();
  const [openPostForm, setOpenPostForm] = useState<boolean>(false);
  const [offersList, setOffersList] = useState<AddOfferValuesType[]>([]);

 
  const addOfferToList = (offerData: AddOfferValuesType) => {
    setOffersList([...offersList, offerData]);
  };

  return (
    <>
      {openPostForm ? (
        <div className="h-[544px]">
          <SchoolPostFormPopupComponent
            addOfferToList={addOfferToList}
          />
        </div>
      ) : (
        <div className="grid-cols-1 grid items-center justify-center text-center mobile:h-[224px] mt-28 mb-48">
          <div className="grid items-center justify-center">
            <img alt="" src="/assets/icons/news-icon.svg" />
          </div>
          <div className="mt-5">
            <p className="text-2xl font-meduim text-zinc-900 font-ar">
              {t("schoolOffers.container.noOffersAvailable")}
            </p>
            <p className="font-ar text-lg text-zinc-500 font-medium mt-3">
              {t("schoolOffers.container.postNewOffer")}
            </p>
            <button
              onClick={() => setOpenPostForm(true)}
              className="w-[122px] h-[43px] bg-mint-500 p-2 text-white font-ar rounded-xl mt-3"
            >
              {t("schoolOffers.container.createPost")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default SchoolOffersContainer;
